// Phase 4 curriculum details for AI-Powered Content Generator
// This file is for code-only storage; admin dashboard integration will follow later.

export const phase4Topics = [
  {
    name: 'Project Introduction: AI-Powered Content Generator',
    order: 1,
    maxTime: null,
    keyConcepts: ['Overview'],
    description: 'Understand the goal: use modern JS (ES6+) and Gemini API to build interactive AI-powered web features.',
    deliverable: 'No video – intro only',
    video: null
  },
  {
    name: 'Ask Me Anything Feature',
    order: 2,
    maxTime: null,
    keyConcepts: ['let/const', 'Arrow Functions', 'Template Literals', 'fetch()', 'Promises'],
    description: 'Build a feature where users type a question and Gemini returns an answer dynamically. Learn event handling, template literals for API queries, and fetch() for asynchronous calls.',
    deliverable: '1 Video: Demonstrate feature + explain ES6 concepts + Gemini API call.',
    video: 1
  },
  {
    name: 'Quick Summarizer Feature',
    order: 3,
    maxTime: null,
    keyConcepts: ['let/const', 'Arrow Functions', 'Template Literals', 'fetch()', 'Promises', 'Destructuring'],
    description: 'Users paste text and receive a concise summary via Gemini. Learn destructuring to extract data from API responses and handle asynchronous results.',
    deliverable: '1 Video: Show summarizer + ES6 features + API integration.',
    video: 1
  },
  {
    name: 'Idea Spark Feature',
    order: 4,
    maxTime: null,
    keyConcepts: ['let/const', 'Arrow Functions', 'Template Literals', 'fetch()', 'Promises', 'Array Methods'],
    description: 'Users request creative ideas (blog topics, stories) from Gemini. Apply array methods to process multiple suggestions if needed.',
    deliverable: '1 Video: Demo feature + explain applied JS/ES6 concepts and API usage.',
    video: 1
  },
  {
    name: 'Definition Finder Feature',
    order: 5,
    maxTime: null,
    keyConcepts: ['let/const', 'Arrow Functions', 'Template Literals', 'fetch()', 'Promises'],
    description: 'Users input terms, and Gemini provides definitions. Practice API request construction, fetch() handling, and DOM manipulation.',
    deliverable: '1 Video: Demo feature + explain ES6/API usage.',
    video: 1
  },
  {
    name: 'Mini Projects / Warm-up Exercises',
    order: 6,
    maxTime: null,
    keyConcepts: ['let/const', 'Arrow Functions', 'Template Literals', 'Destructuring', 'fetch()', 'Promises'],
    description: 'AI Joke Generator, Gemini-Powered Quiz Helper, Daily Positive Affirmation Fetcher. Focused practice on ES6 features + API calls.',
    deliverable: '1 Video per mini-project: Show working demo + explain JS concepts & API integration.',
    video: 3
  },
  {
    name: 'Project Wrap-Up & Reflection',
    order: 7,
    maxTime: null,
    keyConcepts: ['Review All Learned Concepts'],
    description: 'Review ES6 fundamentals (let/const, arrow functions, template literals, destructuring, spread/rest, array methods) and Gemini API integration. Reflect on building a functional, AI-powered web app.',
    deliverable: '1 Video: Demonstrate final AI content generator + reflect on learning outcomes.',
    video: 1
  }
];
